(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  const primeDealsSectionHeader = document.querySelector('.section-header');
  const primeDealsHeaderWrapper = document.querySelector('.header-wrapper--primedeals');

  if (primeDealsSectionHeader && primeDealsHeaderWrapper) {
    const stickyMenuDetails = primeDealsHeaderWrapper.querySelector('header-drawer > details');
    const stickyMenuSummary = stickyMenuDetails?.querySelector('summary');
    const desktopMenuQuery = window.matchMedia('(min-width: 990px)');

    const closePrimeDealsStickyMenu = () => {
      primeDealsSectionHeader.classList.remove('prime-menu-expanded');
      stickyMenuSummary?.setAttribute('aria-expanded', false);
      stickyMenuDetails?.removeAttribute('open');
      stickyMenuDetails?.classList.remove('menu-opening');
      document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
    };

    stickyMenuSummary?.addEventListener(
      'click',
      (event) => {
        if (!desktopMenuQuery.matches || !primeDealsSectionHeader.classList.contains('scrolled-past-header')) return;

        event.preventDefault();
        event.stopImmediatePropagation();

        const menuWillOpen = !primeDealsSectionHeader.classList.contains('prime-menu-expanded');
        primeDealsSectionHeader.classList.toggle('prime-menu-expanded', menuWillOpen);
        stickyMenuSummary.setAttribute('aria-expanded', menuWillOpen);
        stickyMenuDetails.removeAttribute('open');
        stickyMenuDetails.classList.remove('menu-opening');
        document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');

        requestAnimationFrame(() => {
          stickyMenuDetails.removeAttribute('open');
          stickyMenuDetails.classList.remove('menu-opening');
          document.body.classList.remove('overflow-hidden-tablet', 'overflow-hidden-desktop');
        });
      },
      true
    );

    window.addEventListener('scroll', () => {
      requestAnimationFrame(() => {
        if (!primeDealsSectionHeader.classList.contains('scrolled-past-header')) closePrimeDealsStickyMenu();
      });
    });

    desktopMenuQuery.addEventListener('change', closePrimeDealsStickyMenu);

    document.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') closePrimeDealsStickyMenu();
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primedeals-faq-tabs"] && !Shopify.designMode) return;
  try {
    
  (() => {
    document.querySelectorAll('[data-pd-faq]').forEach((root) => {
      const tabs = Array.from(root.querySelectorAll('[data-pd-faq-tab]'));
      const panels = Array.from(root.querySelectorAll('[data-pd-faq-panel]'));
      if (!tabs.length || !panels.length) return;

      const activate = (nextTab) => {
        const key = nextTab.dataset.categoryKey;

        tabs.forEach((tab) => {
          const isActive = tab === nextTab;
          tab.classList.toggle('pd-faq__tab--active', isActive);
          tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
          tab.tabIndex = isActive ? 0 : -1;
        });

        panels.forEach((panel) => {
          const isActive = panel.dataset.categoryKey === key;
          panel.classList.toggle('pd-faq__panel--active', isActive);
          panel.hidden = !isActive;
        });
      };

      tabs.forEach((tab) => {
        tab.addEventListener('click', () => activate(tab));

        tab.addEventListener('keydown', (event) => {
          const index = tabs.indexOf(tab);
          let nextIndex = index;

          if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') nextIndex = 0;
          if (event.key === 'End') nextIndex = tabs.length - 1;

          if (nextIndex !== index) {
            event.preventDefault();
            tabs[nextIndex].focus();
            activate(tabs[nextIndex]);
          }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["primedeals-footer"]) return;
  try {
    
  (() => {
    const button = document.querySelector('[data-pd-back-to-top]');
    if (!button) return;

    const toggleVisibility = () => {
      button.classList.toggle('pd-footer__back-to-top--visible', window.scrollY > 400);
    };

    button.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });

    window.addEventListener('scroll', toggleVisibility, { passive: true });
    toggleVisibility();
  })();

  } catch(e) { console.error(e); }
})();
})();
